<script setup>

import { ref, inject } from 'vue';

import Listbox from 'primevue/listbox';
import Routine from './Routine.vue';
import ModaleAjoutRoutine from './ModaleAjoutRoutine.vue';

const { routines } = defineProps({
	routines: Array
});

const emit = defineEmits(['editionArguments']);

const selectionSchema = inject('selectionSchema');

const affichageModaleAjoutRoutine = ref(false);

function afficherModaleAjoutRoutine() {
	affichageModaleAjoutRoutine.value = true;
}

function afficherModaleEditionArguments() {
	emit('editionArguments', true);
}

</script>

<template>
	<div>
		<div class="entete">
			<label class="titre">Routines</label>
			<div class="conteneur-boutons">
				<button class="bouton fa-solid fa-plus" @click="afficherModaleAjoutRoutine()" />
			</div>
		</div>
		<Listbox class="liste-routines" 
		  v-model="selectionSchema.routine" 
		  :options="routines"
		  :selectOnFocus="true"
		  :emptyMessage="'Aucune routine'"
		  :optionLabel="'nom'"
		  :disabled="!routines.length">
			<template #option="slotProps">
				<Routine :routine="slotProps.option" :selectionnee="slotProps.option === selectionSchema.routine" />
			</template>
		</Listbox>
		<ModaleAjoutRoutine 
		  v-model:visible="affichageModaleAjoutRoutine"
		  @edition-arguments="afficherModaleEditionArguments" />
	</div>
</template>

<style scoped>

.liste-routines {
	height: 15vh !important;
	overflow: auto;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

</style>